export const formatStringForCSV = (s: string | null | undefined): string => {
   if (s === null || s === undefined) {
      return '';
   }

   return s.replaceAll('"', '""');
};
